import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { dossierStatusesForProcessTypeQuery } from '@app/pcs/data/dossier-status.queries';
import { DictionaryEntity } from '@app/pcs/models';
import { Observable } from 'rxjs';

@Injectable()
export class DossierStatusDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetchDossierStatusesForProcessType(processType: DictionaryEntity): Observable<DictionaryEntity[]> {
    return this.graphqlService.query(dossierStatusesForProcessTypeQuery, {processType}, hideLoader());
  }
}
